import ApiModel  from '@widesk-core/models/ApiModel';
import fileStore from '@/stores/fileStore';

/**
 * Le fichier de ce type porté par ce modèle, s'il y en a un.
 *
 * Dans son propre module plutôt qu'à côté de `EditableImage` : les écrans qui affichent l'image sans
 * la modifier s'en servent aussi (l'aperçu d'un point d'intérêt), et un fichier qui exporte autre
 * chose que des composants coupe le rechargement à chaud de React.
 */
export default function imageOf(model: ApiModel, reference: File_StonecodeFileTypeReference) {
	return fileStore
		.getFilesForModel(model, { fetchCollection: true })
		.find(f => f.typeSource.type.reference === reference);
}
